import { render, staticRenderFns } from "./WineriesList.vue?vue&type=template&id=caaf36f6&"
import script from "./WineriesList.vue?vue&type=script&lang=js&"
export * from "./WineriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports